"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: ", ";\n"], ["\n  padding-bottom: ", ";\n  padding-left: ", ";\n  padding-right: ", ";\n  padding-top: ", ";\n"]);

var _arenaConfig = require("arena-config");

var c = _interopRequireWildcard(_arenaConfig);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require("./propTypes");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledPadding = _styledComponents2.default.div(_templateObject, function (props) {
  return props.bottom || props.vertical || props.all ? c.size(props.bottom || props.vertical || props.all) + "px" : undefined;
}, function (props) {
  return props.left || props.horizontal || props.all ? c.size(props.left || props.horizontal || props.all) + "px" : undefined;
}, function (props) {
  return props.right || props.horizontal || props.all ? c.size(props.right || props.horizontal || props.all) + "px" : undefined;
}, function (props) {
  return props.top || props.vertical || props.all ? c.size(props.top || props.vertical || props.all) + "px" : undefined;
});

var Padding = function Padding(_ref) {
  var all = _ref.all,
      bottom = _ref.bottom,
      children = _ref.children,
      horizontal = _ref.horizontal,
      left = _ref.left,
      right = _ref.right,
      top = _ref.top,
      vertical = _ref.vertical;
  return _react2.default.createElement(StyledPadding, {
    all: all,
    bottom: bottom,
    horizontal: horizontal,
    left: left,
    right: right,
    top: top,
    vertical: vertical
  }, children);
};

Padding.defaultProps = _propTypes.paddingDefaultProps;
Padding.propTypes = _propTypes.paddingPropTypes;
exports.default = Padding;